import { Link } from "react-router-dom";
import amyPortrait from "@/assets/amy.jpg";
import amyPortraitWebp from "@/assets/amy.webp";
import bilousPortrait from "@/assets/bilous.png";
import bilousPortraitWebp from "@/assets/bilous.webp";
import Picture from "@/components/Picture";

export default function About() {
  return (
    <section id="about" className="bg-cream-50">
      <div className="section">
        <p className="eyebrow">Meet your orthodontists</p>

        <div className="mt-10 space-y-16 border-b border-sage-100 pb-16">
          <DoctorProfile
            portrait={amyPortrait}
            portraitWebp={amyPortraitWebp}
            alt="Portrait of Dr. Amy Harel"
            title="Dr. Amy Harel — orthodontics with heart, precision, and a love for the craft."
            bioLink="/dr-amy"
            bioLinkLabel="Read Dr. Amy's full bio"
          >
            <p>
              Dr. Amy grew up in New York City and graduated{" "}
              <em>summa cum laude</em> from the University at Buffalo Honors
              College with a degree in Biology. She continued at the University
              at Buffalo School of Dental Medicine, finishing in the top 5% of
              her class — and went straight into the orthodontic residency at
              the University of Detroit Mercy, where she earned her Certificate
              in Orthodontics and a Master of Science studying the effects of
              orthodontic appliances on temporo-mandibular joint (TMJ)
              remodeling.
            </p>
          </DoctorProfile>

          <DoctorProfile
            portrait={bilousPortrait}
            portraitWebp={bilousPortraitWebp}
            alt="Portrait of Dr. Oresta Bilous"
            title="Dr. Oresta Bilous — changing smiles across generations of Fairfield County families."
            bioLink="/dr-bilous"
            bioLinkLabel="Read Dr. Bilous's Full Bio"
          >
            <p>
              Dr. Bilous grew up in upstate New York and earned her DMD{" "}
              <em>Magna Cum Laude</em> from Tufts University School of Dental
              Medicine before completing her orthodontic residency in Boston in
              2001.               She feels fortunate to treat generations of families and
              watch her younger patients grow into amazing adults.
            </p>
          </DoctorProfile>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-3">
          <Pillar title="Patient-first" copy="Care plans built around your goals, schedule, and budget." />
          <Pillar title="Modern technology" copy="Digital scans and clear treatment options for comfortable results." />
          <Pillar title="Two locations" copy="Convenient offices in Fairfield and Orange, Connecticut." />
        </div>
      </div>
    </section>
  );
}

function DoctorProfile({
  portrait,
  portraitWebp,
  alt,
  title,
  bioLink,
  bioLinkLabel,
  children,
}: {
  portrait: string;
  portraitWebp: string;
  alt: string;
  title: string;
  bioLink: string;
  bioLinkLabel: string;
  children: React.ReactNode;
}) {
  return (
    <div className="grid gap-14 lg:grid-cols-12 lg:gap-12">
      <div className="lg:col-span-5">
        <div className="relative mx-auto aspect-[4/5] max-w-sm overflow-hidden rounded-[2rem] border border-cream-300/60 bg-sage-100 shadow-soft">
          <Picture
            webp={portraitWebp}
            src={portrait}
            alt={alt}
            className="h-full w-full object-cover"
          />
        </div>
      </div>

      <div className="lg:col-span-7 lg:pt-6">
        <h2 className="text-3xl sm:text-4xl">{title}</h2>
        <div className="mt-6 space-y-5 text-sage-700/90">{children}</div>
        <div className="mt-8">
          <Link to={bioLink} className="btn-secondary">
            {bioLinkLabel}
          </Link>
        </div>
      </div>
    </div>
  );
}

function Pillar({ title, copy }: { title: string; copy: string }) {
  return (
    <div className="rounded-2xl border border-sage-100 bg-cream-100/60 p-5">
      <h3 className="font-serif text-lg text-sage-800">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-sage-700/90">{copy}</p>
    </div>
  );
}
